var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTotalDownloadModel = function SvgIconTotalDownloadModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M10.002 3.417c.489 0 .885.396.885.885v7.16l2.471-2.472a.885.885 0 1 1 1.252 1.252L11.254 13.6a1.77 1.77 0 0 1-2.505 0l-3.358-3.358a.885.885 0 1 1 1.252-1.252l2.473 2.472V4.302c0-.489.396-.885.886-.885m-6.2 9.74a.885.885 0 1 0-1.77 0v1.77a2.656 2.656 0 0 0 2.655 2.656h10.625a2.656 2.656 0 0 0 2.656-2.656v-1.77a.885.885 0 1 0-1.77 0v1.77a.885.885 0 0 1-.886.886H4.687a.885.885 0 0 1-.885-.886z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTotalDownloadModel;